import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import './SimPuzzleQuestion.scss';

export default function SimPuzzleQuestion({ sim, setQuestion, question }) {
    const { t } = useTranslation();

    const zones = question.meta ?? [];
    const zoneCount = zones.length;

    // local drag state
    const [dragging, setDragging] = useState(null);

    useEffect(() => {
        setDragging(null);
    }, [sim.currentQuestion]);

    const dropped = question.answer ?? {};
    const normalizePuzzleAnswer = (answer) => {
        const out = {};
        Object.keys(answer).forEach((k) => {
            out[Number(k)] = Number(answer[k]);
        });
        return out;
    };
    const onDrop = (zoneIdx) => {
        if (dragging === null || sim.finished) return;

        const next = normalizePuzzleAnswer({ ...dropped, [zoneIdx]: dragging });

        setQuestion(sim.currentQuestion, {
            ...question,
            answer: next,
            is_correct: isCorrect(next),
        });

        setDragging(null);
    };

    const isCorrect = (answers) => {
        if (Object.keys(answers).length !== zoneCount) return false;

        for (let i = 0; i < zoneCount; i++) {
            if (answers[i] !== i + 1) return false;
        }
        return true;
    };

    const clearPuzzle = () => {
        if (sim.finished) return;

        setQuestion(sim.currentQuestion, {
            ...question,
            answer: {},
            is_correct: false,
        });
    };

    const good = question.is_correct === true;

    return (
        <div className={"exam-sim-question puzzle " + (question.image_uri ? "has-image" : "")}>
            <h2 className="exam-sim-question-title">
                {question.question}
            </h2>

            <div className="exam-sim-question-body">
                <div className="exam-sim-question-image puzzle-image-wrapper">
                    <div className="puzzle-image-container">
                        <img src={question.image_uri} alt="" />

                        {/* ZONES */}
                        {zones.map((z, idx) => (
                            <div
                                key={idx}
                                className="puzzle-zone"
                                style={{
                                    top: z.top,
                                    left: z.left,
                                    paddingTop: z.size,
                                    "--zone-size": z.size,
                                }}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={() => onDrop(idx)}
                            >
                                {dropped[idx] && (
                                    <div className="puzzle-number locked">
                                        {dropped[idx]}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <ul className="exam-sim-question-answers">
                    {/* DRAGGABLE NUMBERS */}
                    <li>
                        <div className="puzzle-numbers">
                            {Array.from({ length: zoneCount }, (_, i) => i + 1).map(
                                (n) => (
                                    <div
                                        key={n}
                                        className={
                                            "puzzle-number " +
                                            (Object.values(dropped).includes(n)
                                                ? "used"
                                                : "")
                                        }
                                        draggable={!sim.finished}
                                        onDragStart={() => setDragging(n)}
                                    >
                                        {n}
                                    </div>
                                )
                            )}
                        </div>
                    </li>

                    {!sim.finished && Object.keys(dropped).length > 0 && (
                        <li className="exam-sim-question-actions">
                            <button
                                type="button"
                                className="btn btn-secondary btn-puzzle-clear"
                                onClick={clearPuzzle}
                            >
                                {t("button.reset")}
                            </button>
                        </li>
                    )}

                    {sim.finished && question.explanation && (
                        <li
                            className={
                                "exam-sim-question-desc " +
                                (good ? "good" : "wrong")
                            }
                        >
                            {good ? <h3>{t("good")}</h3> : <h3>{t("wrong")}</h3>}
                            {question.explanation}
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
}